import { ref, watch } from 'vue'

export default function useSnackBar() {
	const isShow = ref(false)
	const isProcess = ref(false)
	const timeoutObject = ref<null | ReturnType<typeof setTimeout>>(null)
	const messages = ref<string[]>([])
	const message = ref<string | null>(null)

	function addMessage(message: string) {
		messages.value.push(message)
	}

	function removeMessage() {
		messages.value.shift()
	}

	function showMessage() {
		isProcess.value = true
		message.value = messages.value[0]
		isShow.value = true
		const timeout = message.value === null ? 0 : 3000
		timeoutObject.value = setTimeout(() => {
			closeMessage()
		}, timeout)
	}

	function closeMessage() {
		timeoutObject.value = null
		isShow.value = false
		removeMessage()
		message.value = null
		isProcess.value = false
	}

	function dismiss() {
		if (timeoutObject.value !== null) {
			clearTimeout(timeoutObject.value)
		}
		closeMessage()
	}

	function messageChangeEvent() {
		setTimeout(() => {
			if (messages.value.length > 0 && !isProcess.value && !isShow.value) {
				showMessage()
			}
		}, 150)
	}

	watch(
		() => messages.value,
		() => {
			messageChangeEvent()
		},
		{
			immediate: true,
			deep: true,
		},
	)

	return {
		isShow,
		isProcess,
		messages,
		message,
		addMessage,
		removeMessage,
		showMessage,
		closeMessage,
		dismiss,
		messageChangeEvent,
	}
}
